<div class="card">
    <mat-spinner class="spinner" *ngIf="!done"></mat-spinner>
    <div *ngIf="done" class="null"><h2>Le guide s'ouvre dans une nouvelle fenêtre</h2></div>
</div>

